export default {
  props: {
    background: {
      type: Boolean,
      default: true
    },
    bottom: {
      type: Boolean,
      default: true
    },
    themeColor: {
      type: String,
      default: ''
    }
  }
};